<!-- Back Button -->
<div class="container">
  <div class="pt-lg-4">
    <div class="text-white cursor-pointer d-none d-lg-flex btn-circle-gloss bg-glass" (click)="goBack()">
      <span class="material-icons pe-1">arrow_back_ios_new</span>
    </div>
  </div>
</div>

<div class="container">
  <fgb-points-summary-bar [backButtonLink]="'/rewards/raffles'" [backButtonTitle]="'Raffles'"></fgb-points-summary-bar>
</div>

<fgbcl-marketplace-details [itemId]="id" [actionLabels]="actionLabels"></fgbcl-marketplace-details>
